<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from '#imports';
import lottie from 'lottie-web';
import open1Json from '~/assets/lottie/training/open1.json';
import open2Json from '~/assets/lottie/training/open2.json';
import status1Json from '~/assets/lottie/training/status1.json';
import status2Json from '~/assets/lottie/training/status2.json';
import status3Json from '~/assets/lottie/training/status3.json';

const emit = defineEmits(['animation-finish']);

const { receive = false } = defineProps<{
  receive?: boolean;
}>();

const step = ref(0);
const lottieInst = ref();
const containerRef = ref();
const dataArr = [status1Json, status2Json, status3Json];

function init() {
  const index = Math.floor(Math.random() * 3);
  const data = dataArr[index];
  showAnimation(data);
}

function showAnimation(animationData: any, loop = true) {
  if (lottieInst.value) {
    lottieInst.value.destroy();
  }
  lottieInst.value = lottie.loadAnimation({
    container: containerRef.value as Element,
    renderer: 'svg',
    loop,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });
  lottieInst.value.addEventListener('complete', () => {
    if (step.value === 2) {
      step.value = 0;
      lottieInst.value.destroy();
    } else if (step.value === 1) {
      emit('animation-finish', step.value);
      startNextReceiveAnimation();
    }
  });
}

function startReceiveAnimation() {
  step.value = 1;
  showAnimation(open1Json, false);
}

function startNextReceiveAnimation() {
  step.value = 2;
  showAnimation(open2Json, false);
}

watch(
  () => receive,
  () => {
    if (receive) {
      startReceiveAnimation();
    } else {
      init();
    }
  },
);

const animationClass = computed(() => {
  if (step.value === 2) {
    return 'fixed bottom-0 left-0 right-0 top-0 z-10 m-auto h-[540px] w-[686px]';
  } else if (step.value === 1) {
    return 'absolute bottom-6 right-12 z-10 h-[113px] w-[113px]';
  } else {
    return 'absolute bottom-6 right-24 z-10 h-[51px] w-[90px]';
  }
});

onMounted(() => {
  init();
});

onBeforeUnmount(() => {
  if (lottieInst.value) {
    lottieInst.value.destroy();
  }
});
</script>

<template>
  <div ref="containerRef" :class="animationClass"></div>
</template>

<style scoped></style>
